export const FORM_GENERATION_FIELD_NAME = {
  FORM_ID: 'formId',
  BORROWER_ID: 'borrowerId',
};
